import { Link, useSearchParams } from 'react-router-dom';
import { FiHome } from 'react-icons/fi';
import SurveyForm from './SurveyForm';

export default function SurveyLanding() {
    const [searchParams] = useSearchParams();
    if ((searchParams.get('t') || '').trim()) return <SurveyForm />;

    return (
        <main className="survey-page">
            <div className="survey-glow survey-glow-one" />
            <div className="survey-glow survey-glow-two" />
            <section className="survey-shell survey-landing">
                <Link className="survey-home-link" to="/"><FiHome /> بازگشت به صفحه اصلی</Link>
            </section>
        </main>
    );
}
